"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var cssAnchorName = 'social-buttons-google';
exports.cssAnchorName = cssAnchorName;

var GoogleButton = function GoogleButton(_ref) {
  var href = _ref.href,
      phrase = _ref.phrase,
      imageSrc = _ref.imageSrc;
  return (0, _preact.h)("a", {
    target: "_top",
    href: (0, _absoluteUrlRuntime.resolveUrl)(href),
    className: (0, _classnames.default)('btn--cta', 'btn--sso', 'qa-sso-google'),
    style: {
      display: 'flex',
      fontFamily: 'Roboto',
      alignItems: 'center',
      background: 'white',
      color: '#737373',
      border: '1px solid #dadce0',
      boxShadow: 'none'
    }
  }, (0, _preact.h)("div", {
    style: {
      flex: 1
    }
  }, (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(imageSrc),
    alt: "Google Login",
    style: {
      height: '18px',
      float: 'left'
    }
  })), (0, _preact.h)("div", null, phrase), (0, _preact.h)("div", {
    style: {
      flex: 1
    }
  }));
};

var _default = GoogleButton;
exports.default = _default;